export default __webpack_public_path__ + "static/media/logoo.f85ecc51.png";